
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/casos/br-com",
      function () {
        return require("private-next-pages/[locale]/casos/br-com.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/casos/br-com"])
      });
    }
  